import React from 'react';
import { X } from 'phosphor-react';
import { Modal } from '@material-ui/core';

import {
  closePreapprovedFalseModal,
  closePreapprovedTrueModal,
  openPreapprovedContactModal,
} from '../../../../../actions/dashboard';
import { DocumentBlob } from '../../../../utility/Icons';
import styles from '../../../../../styles/sass/components/GetPreapproved.module.scss';
import { connect } from 'react-redux';
import {
  sendRequestForLenderIntroduction,
  updateProfile,
} from '../../../../../actions/auth';

interface Props {
  modalStyle: any;
  showPreapprovedFalseModal: boolean;
  dispatch: Function;
  token: string;
  user: any;
}

export const renderInitialPart = (dispatch: Function) => {
  return (
    <div>
      <div className={styles.header}>
        <DocumentBlob
          width="66"
          height="60"
          style={{ margin: '24px 0 0 24px' }}
        />
        <button
          className={styles.closePhoto}
          onClick={() => {
            dispatch(closePreapprovedFalseModal());
            dispatch(closePreapprovedTrueModal());
          }}
        >
          <X size={32} color="#323232" weight="regular" />
        </button>
      </div>
      <div className={styles.body}>
        <p className={styles.headingText1}>Get Pre-Approved</p>
        <p className={styles.headingText2}>What does pre-approval mean?</p>
        <p className={styles.subText}>
          Pre-approval is the process by which a bank or lender evaluates your
          finances and credit history to determine if you are eligible for a
          mortgage. If you qualify, you will receive a pre-approval letter,
          which shows how much you can afford.
        </p>
        <p className={styles.headingText2}>Why is pre-approval important?</p>
        <p className={styles.subText}>
          In competitive markets, it's important for buyers to be pre-approved
          so that they can act quickly when they find the right home. Sellers
          expect buyers to be pre-approved to ensure that the deal won’t fall
          through due to financing issues.
        </p>
      </div>
    </div>
  );
};

export const PreapprovedFalseModal: React.FC<Props> = ({
  modalStyle,
  showPreapprovedFalseModal,
  dispatch,
  token,
  user,
}) => {
  const nextScreen = () => {
    dispatch(sendRequestForLenderIntroduction(token, true));
    dispatch(
      updateProfile(
        { onboarding: { ...user.onboarding, lenderIntroduced: true } },
        token,
        false,
        true,
      ),
    );
    // Close the current modal
    dispatch(closePreapprovedFalseModal());
    // Open the next modal
    dispatch(openPreapprovedContactModal());
  };

  return (
    <Modal
      open={showPreapprovedFalseModal}
      onClose={() => dispatch(closePreapprovedFalseModal())}
      style={modalStyle}
    >
      <div className={styles.preapprovedFalseModal}>
        {renderInitialPart(dispatch)}
        <div className={styles.requirementsContainer}>
          <p className={styles.requirements}>
            In order to complete this task, you will just need to let us know
            that you need to be introduced to one of our trusted lending
            partners.
          </p>
        </div>
        <div className={styles.buttonContainer}>
          <button className={styles.button} onClick={nextScreen}>
            Okay, introduce me
          </button>
        </div>
      </div>
    </Modal>
  );
};

const mapStateToProps = (state: any) => ({
  token: state.auth.token,
  showPreapprovedFalseModal: state.dashboard.showPreapprovedFalseModal,
  user: state.auth.user,
});

export default connect(mapStateToProps)(PreapprovedFalseModal);
